<template>
  <div class="container">
    <section class="main-content">
      <HeroHeader />
      <div class="layout-body">
        <HeroSidebar :class="{ activeToggle: $store.state.isToggle }" />
        <section class="content-area">
          <div class="header-title">
            <h3>{{ $route.meta.title }}</h3>
            <h3 class="subtitle">
              {{ $route.meta.subtitle ? ` > ${$route.meta.subtitle}` : "" }}
            </h3>
          </div>
          <div class="panel">
            <router-view />
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import HeroSidebar from "@/components/common/HeroSidebar.vue";
import HeroHeader from "@/components/common/HeroHeader.vue";

export default {
  components: { HeroSidebar, HeroHeader },
  setup() {
    return {};
  },
};
</script>

<style scoped>

.container {
  display: flex;
  min-height: 100vh;
  overflow: hidden;
  background-color: white;
}

.main-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.layout-body {
  display: flex;
  flex: 1;
  height: 100%;
  overflow: hidden;
}

.layout-body > .content-area {
  flex: 1;
  margin: 25px 20px;
}

.content-area .header-title {
  display: flex;
  align-items: center;
}

.content-area .header-title h3 {
  color: var(--font-color-four);
  font-weight: 500;
  font-size: 16px;
}

.content-area .header-title .subtitle {
  color: var(--font-color-three);
}

.content-area .panel {
  margin-top: 12px;
}

@media only screen and (min-width: 320px) and (max-width: 440px) {
  .content-area .header-title h3 {
    font-size: 13px;
  }
  .content-area .header-title .subtitle {
    color: var(--font-color-three);
  }
}
</style>
